import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.anchor";
import { __rest } from "tslib";
import { isArray, isString } from 'vega-util';
export function extractTitleConfig(titleConfig) {
  var anchor = titleConfig.anchor,
      frame = titleConfig.frame,
      offset = titleConfig.offset,
      orient = titleConfig.orient,
      color = titleConfig.color,
      subtitleColor = titleConfig.subtitleColor,
      subtitleFont = titleConfig.subtitleFont,
      subtitleFontSize = titleConfig.subtitleFontSize,
      subtitleFontStyle = titleConfig.subtitleFontStyle,
      subtitleFontWeight = titleConfig.subtitleFontWeight,
      subtitleLineHeight = titleConfig.subtitleLineHeight,
      subtitlePadding = titleConfig.subtitlePadding,
      titleMarkConfig = __rest(titleConfig, ["anchor", "frame", "offset", "orient", "color", "subtitleColor", "subtitleFont", "subtitleFontSize", "subtitleFontStyle", "subtitleFontWeight", "subtitleLineHeight", "subtitlePadding"]);

  var mark = Object.assign(Object.assign({}, titleMarkConfig), color ? {
    fill: color
  } : {});
  var nonMark = Object.assign(Object.assign(Object.assign(Object.assign({}, anchor ? {
    anchor: anchor
  } : {}), frame ? {
    frame: frame
  } : {}), offset ? {
    offset: offset
  } : {}), orient ? {
    orient: orient
  } : {});
  var subtitle = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, subtitleColor ? {
    subtitleColor: subtitleColor
  } : {}), subtitleFont ? {
    subtitleFont: subtitleFont
  } : {}), subtitleFontSize ? {
    subtitleFontSize: subtitleFontSize
  } : {}), subtitleFontStyle ? {
    subtitleFontStyle: subtitleFontStyle
  } : {}), subtitleFontWeight ? {
    subtitleFontWeight: subtitleFontWeight
  } : {}), subtitleLineHeight ? {
    subtitleLineHeight: subtitleLineHeight
  } : {}), subtitlePadding ? {
    subtitlePadding: subtitlePadding
  } : {});
  return {
    mark: mark,
    nonMark: nonMark,
    subtitle: subtitle
  };
}
export function isText(v) {
  return isString(v) || isArray(v) && isString(v[0]);
}